import {
  ScrollView,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native"
import { cn } from "@/components/util/cn"
import { Body, H6, Small } from "@/components/standard/BFText"
import React from "react"
import { Portal } from "@rn-primitives/portal"

export interface BFDropDownOption {
  value: string
  label: string
  subLabel?: string
}

export const BFDropDownPopover = ({
  options,
  open,
  onSelect,
  dropdownLayout,
  emptyMessage,
}: {
  dropdownLayout?: { x: number; y: number; width: number; height: number }
  onSelect: (option: BFDropDownOption) => void
  open: boolean | undefined
  options: BFDropDownOption[]
  emptyMessage?: string // Optional message to show when no options are available
}) => {
  if (!dropdownLayout) {
    return null
  }

  // const optionsWidth = fullWidth ? dropdownLayout.width : 260
  const optionsWidth = Math.max(dropdownLayout.width, 260)

  return (
    <Portal name={"autocomplate"}>
      {open && (
        <View
          style={{
            position: "absolute",
            top: dropdownLayout.y + dropdownLayout.height + 4,
            left: dropdownLayout.x + dropdownLayout.width - optionsWidth,
            width: optionsWidth,
            backgroundColor: "#fff",
            elevation: 2,
            shadowColor: "#000",
            shadowOffset: { width: 1, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 1.2,
          }}
          className="border border-light-grey rounded-md bg-lightest"
        >
          <TouchableWithoutFeedback>
            <View>
              <ScrollView nestedScrollEnabled={true} style={{}}>
                {options.map((item, index) => (
                  <TouchableOpacity
                    key={index}
                    testID={`option-${String(item.value)}`}
                    activeOpacity={0.1}
                    onPress={() => {
                      onSelect(item)
                    }}
                    className={cn(
                      "bg-lightest",
                      "px-4 py-3 border-b border-light-grey last:border-b-0 flex-col hover:bg-grey"
                    )}
                  >
                    <H6 className={cn("text-dark-grey")}>{item.label}</H6>
                    {item.subLabel && <Small>{item.subLabel}</Small>}
                  </TouchableOpacity>
                ))}
                {emptyMessage && (!options || options.length === 0) && (
                  <Body className={"px-4 py-3"} color={"primaryLight"}>
                    {emptyMessage}
                  </Body>
                )}
              </ScrollView>
            </View>
          </TouchableWithoutFeedback>
        </View>
      )}
    </Portal>
  )
}
